import Actions from "./Actions";
import React from "react";
import StatusBadge from "@/components/StatusBadge";

export const columns = (handleOnClickDelete) => {
  return [
    {
      accessorKey: "actions",
      header: "Actions",
      enableResizing: false,
      enableSorting: false,
      cell: ({ row }) => (
        <Actions row={row} handleOnClickDelete={handleOnClickDelete} />
      ),
    },
    {
      accessorKey: "first_name",
      header: "First Name",
      cell: ({ row }) => <div>{row.getValue("first_name")}</div>,
    },
    {
      accessorKey: "last_name",
      header: "Last Name",
      cell: ({ row }) => <div>{row.getValue("last_name")}</div>,
    },
    {
      accessorKey: "email",
      header: "Email",
      cell: ({ row }) => <div>{row.getValue("email")}</div>,
    },
    {
      accessorKey: "roles",
      header: "Roles",
      cell: ({ row }) => (
        <div>
          {row.getValue("roles")?.map((role) => (
            <div key={role.id}>{role.name}</div>
          ))}
        </div>
      ),
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
  ];
};
